module.exports = __webpack_public_path__ + "static/deco1-634c9d732a6f3374e06563652372d1f4.svg";